export default __webpack_public_path__ + "static/media/cards.d5dcbfb7.png";